/** Pragmatic email shape check — good enough to catch paste typos. */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value: string): boolean =>
  EMAIL_RE.test(value.trim());

/**
 * Splits a pasted blob (commas, semicolons, whitespace, newlines) into a
 * de-duplicated, lowercased email list, preserving first-seen order.
 */
export const parseEmails = (raw: string): string[] => {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const token of raw.split(/[\s,;]+/)) {
    const email = token.trim().toLowerCase();
    if (email && !seen.has(email)) {
      seen.add(email);
      result.push(email);
    }
  }
  return result;
};
